import * as types from "./actionTypes";
import log from "../utils/log";

export const appRequestConfig = () => {
  log.info("[APP ACTION] APP_REQUEST_CONFIG");
  return {
    type: types.APP_REQUEST_CONFIG
  };
};

export const appRequestConfigEnd = (config) => {
  log.info("[APP ACTION] APP_REQUEST_CONFIG_END");
  return {
    type: types.APP_REQUEST_CONFIG_END,
    config
  };
};

export const appRequestI18n = () => {
  log.info("[APP ACTION] APP_REQUEST_I18N");
  return {
    type: types.APP_REQUEST_I18N
  };
};

export const appRequestI18nEnd = (i18n) => {
  log.info("[APP ACTION] APP_REQUEST_I18N_END");
  return {
    type: types.APP_REQUEST_I18N_END,
    i18n
  };
};

export const appRequestUserlistEnd = (userList) => {
  log.info("[APP ACTION] APP_REQUEST_USERLIST_END");
  return {
    type: types.APP_REQUEST_USERLIST_END,
    userList
  };
};

export const appFlushDatas = () => {
  log.info("[APP ACTION] APP_FLUSH_DATAS");
  return {
    type: types.APP_FLUSH_DATAS
  };
};

export const appOnLoginPage = () => {
  log.info("[APP ACTION] APP_ON_LOGIN_PAGE");
  return {
    type: types.APP_ON_LOGIN_PAGE
  };
};




// WEBPACK FOOTER //
// ./src/actions/appActions.js